<template>
    <div class="customer-seas-share-wrap">
        <div class="customer-seas-share-board">
            <div
                class="form-box"
                id="watermark"
                :style="{ backgroundImage: `url(${watermarkUrl})` }"
                v-loading="loading"
            >
                <div class="form-box-title">
                    <p>{{ customerName }}</p>
                    <p>由 {{ userName }} 分享 / 分享于{{ time }}</p>
                </div>
                <div class="form-box-content">
                    <div class="sub-item">
                        <p class="sub-item-title"><span>客户信息</span></p>
                        <div class="sub-item-content">
                            <CustomFormDetailPc
                                v-if="editDetailsShow"
                                :field_list="formInfoList"
                                :form_detail="customerDetail"
                                :pk_id="Number(customer_id)"
                                :is_edit_mode="false"
                                :is_detail_not_edit_mode="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import watermark from "watermark-dom";
import { getFormFields, GetCustomerPublicDetail, GetCustomerPrivateDetail } from "@/api";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
export default {
    name: "CustomerSeasShare",
    components: { CustomFormDetailPc },
    data() {
        return {
            watermarkUrl: null,
            customer_id: "",
            type: "1", // 1:公海，2:私海
            customerName: "",
            userName: "",
            phone: "",
            loading: true,
            formInfoList: [],
            customerDetail: {},
            editDetailsShow: false,
            time: "",
        };
    },
    created() {
        if (this.$route.query) {
            const data = this.$route.query;
            this.customer_id = data.customer_id;
            this.type = data.type;
            this.userName = data.name;
            this.phone = data.phone;
            this.getCustomerDetail();
            const date = new Date();
            const time =
                date.getFullYear() +
                "." +
                (date.getMonth() + 1).toString().padStart(2, "0") +
                "." +
                date.getDate().toString().padStart(2, "0");
            this.time = time;
        }
    },
    mounted() {
        this.createWatermark();
    },
    methods: {
        detailLoadingChange(loading) {
            this.loading = loading;
        },
        getCustomerDetail() {
            getFormFields({
                field_form: "customers",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data.filter((item) => item.field_key !== "salesperson");
                } else {
                    this.$message.error(res.message);
                }
                if (this.type == 1) {
                    GetCustomerPublicDetail(this.customer_id).then((res) => {
                        if (res.code === 200) {
                            this.customerDetail = JSON.parse(JSON.stringify(res.data));
                            this.customerName = this.customerDetail.name && this.customerDetail.name.value;
                            this.editDetailsShow = false;
                            this.$nextTick(() => {
                                this.editDetailsShow = true;
                            });
                        }
                    });
                } else {
                    GetCustomerPrivateDetail(this.customer_id).then((res) => {
                        if (res.code === 200) {
                            this.customerDetail = JSON.parse(JSON.stringify(res.data));
                            this.customerName = this.customerDetail.name && this.customerDetail.name.value;
                            this.editDetailsShow = false;
                            this.$nextTick(() => {
                                this.editDetailsShow = true;
                            });
                        }
                    });
                }
                this.loading = false
            });
        },
        createWatermark() {
            const options = {
                watermark_parent_node: "watermark",
                watermark_txt: this.userName + this.phone,
                watermark_color: "gray",
                watermark_fontsize: "16px",
                watermark_rows: 6, //水印行数
                watermark_cols: 6, // 水印列数
                watermark_x: 20, //水印起始位置x轴坐标
                watermark_y: 0, //水印起始位置Y轴坐标
                watermark_x_space: -10,
                watermark_angle: 45,
            };
            watermark.load(options);
        },
    },
};
</script>
<style lang="scss" scoped>
.customer-seas-share-wrap {
    width: 100%;
    height: 100vh;
    background: url(https://download.hecoos.com/enlightv/2024-04/eSKDGcX5iprHf4Ekm2Eb.jpg) no-repeat;
    background-size: 100% 100%;

    .customer-seas-share-board {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .form-box {
        width: 560px;
        height: 600px;
        padding-top: 16px;
        box-sizing: border-box;
        border-radius: 8px;
        background: #ffffff;
        box-sizing: border-box;
        background-size: auto 100%;
        background-repeat: repeat;

        .form-box-title {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
            text-align: center;

            p:nth-child(1) {
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(34, 34, 34, 1);
                margin-bottom: 4px;
            }
        }

        .form-box-content {
            height: calc(100% - 46px);
            padding: 24px 24px 0;
            overflow-y: scroll;
        }

        .sub-item {
            .sub-item-title {
                position: relative;
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
                padding-left: 12px;
                margin-bottom: 16px;

                &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 4px;
                    height: 22px;
                    opacity: 1;
                    border-radius: 20px;
                    background: #2990ff;
                }
            }
        }
    }
}
</style>
